<template>
  <div>
    <ui-modal
      ref="modal"
      :title="`Actualizar Booking Por Aceptar - ID: ${id_by_country}`"
      @close="ActionSetVisibleModalEditarBookingPorAceptar(false), actionSetStateIdDeclarados( null );"
      class="modal-aceptar-booking-por-aceptar"
      size="large"
    >
      <booking-form-component
        :idBooking   = "booking_id"
        :closeModal = "cerrarModal"
      />

    </ui-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

// UI Modal
import UiModal from "keen-ui/src/UiModal";

import BookingFormComponent from "../../../../../components/common/forms/BookingFormComponent.vue";


export default {
  props: {
    idBooking   : { type : Number , default : null } ,
    idByCountry : { type : String , default : null } ,
    load: Boolean,
  },
  data() {
    return {
      booking_id: null,
      id_by_country: "",
      dataAux: [],
    };
  },
  components: {
    UiModal,
    BookingFormComponent,
  },
  computed: {
    ...mapState(["visibleModalEditarBookingPorAceptar"]),
  },
  methods: {
    ...mapActions(["ActionSetVisibleModalEditarBookingPorAceptar","ActionSetZindexTablaModal"]),
    ...mapActions("lineas", [
      "actionSetDatatableVerMisBookingsPorAceptar",
      "actionSetStateIdDeclarados"
    ]),
    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
      this.actionSetStateIdDeclarados( null );
    },
    cerrarModal(){
      this.closeModal("modal") ;
      this.ActionSetZindexTablaModal(false);
    },
  },
  watch: {
    visibleModalEditarBookingPorAceptar: function (_new) {
      _new ? this.openModal("modal") : this.closeModal("modal");
    },
    idBooking: function(_new) {
      if (_new) {
        this.booking_id = + _new ;
      }
    },
    idByCountry: function(_new) {
      if ( _new ) this.id_by_country =  _new ;
    }
  },
};
</script>
